import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { data } from '../Lessons'
import CustomVedio from '../Components/CustomVedio/CustomVedio';
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar';

function Lesson() {

  const { id } = useParams();
  const lessonId = Number(id);
  const lessonData = data.find((item) => item.id === lessonId);
  const [emptyState, setEmptyState] = useState(false);
  const [tabs, setTabs] = useState("1");

  useEffect(() => {
    setTabs("1");

    if (!lessonData) {
      setEmptyState(true);   // في حالة درس غير موجود
      return;
    }

    // 🔥 إزالة الشرط بالكامل — السماح بالدخول لأي درس بدون ترتيب
    setEmptyState(false);

  }, [lessonId, lessonData]);

  return (
    <div className='my-5 px-3 lesson_container'>
      <AuthNavbar />

      {emptyState ? <>Empty</> : <>
        <h5 className='text-right'>{lessonData?.name} : {lessonData?.title}</h5>

        <div className='d-flex my-3'>
          <div className={tabs === "1" ? 'active mx-2 p-2 px-3' : "mx-2 p-2 px-3 tabs"} 
               onClick={() => setTabs("1")}>
            الأهداف
          </div>

          <div className={tabs === "2" ? 'active mx-2 p-2 px-3' : "mx-2 p-2 px-3 tabs"} 
               onClick={() => setTabs("2")}>
            المحتوي
          </div>

          <div className={tabs === "3" ? 'active mx-2 p-2 px-3' : "mx-2 p-2 px-3 tabs"} 
               onClick={() => setTabs("3")}>
            النشاط
          </div>
        </div>

        {tabs === "1" &&
          <p style={{ whiteSpace: 'pre-line', lineHeight: "42px", textAlign: "right" }}>
            {lessonData?.Objectives}
          </p>
        }

        {tabs === "2" &&
          <p style={{ whiteSpace: 'pre-line', lineHeight: "42px", textAlign: "right" }}>
            {lessonData?.content}
          </p>
        }

        {tabs === "3" &&
          <CustomVedio lessonData={lessonData} />
        }
      </>}
    </div>
  );
}

export default Lesson;
